


















































import { Component, Mixins } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import { MatchNoneContent } from "@/models/content/match-none";
import CommonMixin from "@/mixins/common-mixins";
import { AppData } from "@/models/app-data";
import PageLoader from "@/components/PageLoader.vue"

@Component({
  components: {PageLoader},
})
export default class MatchNone extends Mixins(CommonMixin) {
  content: MatchNoneContent = {} as MatchNoneContent;
  appData = {} as AppData;
  textDirection = 'ltr'
  loadDataFinished = false

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getMatchNoneContent();
      this.textDirection = contentService.TextDirection();  

      this.appData = this.getAppData();
      if (this.appData != null) {
        this.appData.preferredProgram = "";
        this.saveAppData(this.appData);
        await this.putWorkflowStep( this.appData.workflowId, "MatchNone") 
        await this.postWorkflowNotEligible(this.appData?.workflowId);
      }
      this.postNavigatedToParent();
      this.loadDataFinished = true
    } catch (error) {
      this.showError(error as any);
    }
  }

  public handleApplyAnyway(): void {
    this.$router.push({ path: "StartApplication" });
  }
}
